import React from 'react';
import Icon, { IconEnum } from '../Icon';
import clsx from 'clsx';
import classes from './styles/loading.module.scss';

interface ILoading {
    isFullScreen?: boolean;
}

const Loading = ({ isFullScreen = true }: ILoading) => {
    return (
        <div className={clsx(isFullScreen && classes.wrapper)}>
            <Icon icon={IconEnum.LOADING} className={classes.loader} />
            <div className={classes.loaderDsk} />
        </div>
    );
};

export default Loading;
